import type { components } from "@cntrl/api-client";

type ShowDetail = components["schemas"]["ShowDetail"];

/** The show PUT is a WHOLE-RECORD write, so a partial edit has to round-trip every other field or the save
 *  wipes them (COMPONENTS: "whole-document PUTs round-trip dormant fields"). This rebuilds the body from the
 *  loaded record so a caller only has to name what it is changing.
 *
 *  It lives here rather than inside `ShowWizard` because the editor is no longer the only writer: the show
 *  preview attaches a flyer too, and a second hand-rolled copy of a whole-record body is exactly how a field
 *  gets dropped on one surface and not the other. */
export function showBodyFrom(d: ShowDetail) {
  return {
    tourId: d.tourId ?? null,
    runId: d.runId ?? null,
    kind: d.kind ?? "show",
    holdTier: d.holdTier ?? null,
    holdExpiresOn: d.holdExpiresOn ?? null,
    date: d.date!,
    timezone: d.timezone ?? null,
    doorsTime: d.doorsTime ?? null,
    venueId: d.venueId ?? null,
    venueName: d.venueName ?? null,
    city: d.city ?? null,
    state: d.state ?? null,
    country: d.country ?? null,
    lat: d.lat ?? null,
    lng: d.lng ?? null,
    capacity: d.capacity ?? null,
    promoter: d.promoter ?? null,
    ticketUrl: d.ticketUrl ?? null,
    ageRestriction: d.ageRestriction ?? null,
    notes: d.notes ?? null,
    flyerMediaId: d.flyerMediaId ?? null,
    contractMediaId: d.contractMediaId ?? null,
    venuePlaceId: d.venuePlaceId ?? null,
  };
}
